import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=5313fdd8&scoped=true"
import script from "./MainMenu.vue?vue&type=script&lang=ts"
export * from "./MainMenu.vue?vue&type=script&lang=ts"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=5313fdd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5313fdd8",
  null
  
)

export default component.exports